<template>
  <div class="page-container">
    <p class="page-title">热门币种配置</p>
    <div class="page-main">
      <el-button type="primary" @click="addHotCoin">新增</el-button>
      <el-table :data="tableData" style="width: 500px">
        <el-table-column prop="coinType" label="币种" width="180">
        </el-table-column>
        <el-table-column prop="score" label="热度值" width="180">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleClick(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :visible="dialogVisible"
      title="添加/修改热门币种"
      width="500px"
      @close="closeDialog"
    >
      <el-form
        :model="txDetail"
        ref="scForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="币种：" prop="coinType">
          <el-select
            :disabled="!isAdd"
            v-model="txDetail.coinType"
            placeholder="请选择"
          >
            <el-option
              v-for="item in coinTypes"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="热度值" prop="score">
          <el-select v-model="txDetail.score" placeholder="请选择">
            <el-option
              v-for="item in scoreArr"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          v-if="!isAdd"
          @click="handleSave(true)"
          style="float:left"
          >删除币种</el-button
        >
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">{{
          isAdd ? '新增' : '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import api from './api';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'hotCoin',
  data() {
    return {
      userid: undefined,
      dialogVisible: false,
      txDetail: {},
      rules: {
        coinType: [{ required: true, message: '请选择币种！' }],
        score: [{ required: true, message: '请选择热度！' }]
      },
      scoreArr: [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5],
      tableData: [],
      isAdd: true
    };
  },
  components: {},
  computed: {
    ...mapState('txRecord', ['coinTypes'])
  },
  methods: {
    ...mapActions('txRecord', ['getCoinTypes']),
    addHotCoin() {
      this.isAdd = true;
      this.txDetail = {};
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    getList() {
      api.getHotCoinList().then(res => {
        this.tableData = res.data;
      });
    },
    handleClick(row) {
      this.isAdd = false;
      this.txDetail = { ...row };
      this.dialogVisible = true;
    },
    compare(prop) {
      return function(obj1, obj2) {
        var val1 = obj1[prop];
        var val2 = obj2[prop];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
        }
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      };
    },
    handleSave(isDel) {
      let that = this;
      this.$refs['scForm'].validate(valid => {
        if (valid) {
          let tableDataCopy = JSON.parse(JSON.stringify(that.tableData));
          let currentIndex = tableDataCopy.findIndex(function(item) {
            return item.coinType === that.txDetail.coinType;
          });

          if (isDel) {
            if (currentIndex !== -1) {
              tableDataCopy.splice(currentIndex, 1);
            }
          } else {
            if (currentIndex !== -1) {
              if (tableDataCopy[currentIndex].score) {
                tableDataCopy[currentIndex].score = that.txDetail.score;
              }
            } else {
              tableDataCopy.push(that.txDetail);
            }
          }
          let reqData = tableDataCopy.sort(that.compare('score')).reverse();
          api
            .hotCoinaddOrUpdate({
              hotCoinConfig: JSON.stringify(reqData)
            })
            .then(res => {
              this.$message({
                message: '添加成功！',
                type: 'success'
              });
              this.dialogVisible = false;
              that.getList();
            });
        }
      });
    }
  },
  created() {
    this.getCoinTypes();
  },
  mounted() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.page-container {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  .page-main {
    margin-top: 20px;
  }
}
</style>
